module.exports = new __parcel__URL__("logo.8fd2eb76.png").toString();